import axios from 'axios'
import { globalReactService } from '@commons'
import { getJwtFromCookies } from '@helpers'

const axiosInstance = axios.create({})
axiosInstance.defaults.timeout = 600000

axiosInstance.interceptors.request.use(
  (config) => {
    axiosInstance.defaults.headers.common.AppID = globalReactService.appID
    config.headers && (config.headers.AppID = globalReactService.appID)

    const jwt = getJwtFromCookies()

    if (jwt) {
      config.headers && (config.headers.Authorization = `Bearer ${jwt}`)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export { axiosInstance }
